import { ReactNode } from 'react'

import { TileContainer } from './styles'

interface IContainerProps {
  children: ReactNode
}

export function Container({ children }: IContainerProps) {
  return <TileContainer>{children}</TileContainer>
}
